const headers = {
  name: "Inventory received",
  navigate: {
    tabs: [
      {
        name: "Received",
        path: "/app/inventory/received",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
